var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { PageLayout } from '../../Components/PageLayout';
import { MainText, Text } from '../../Components/BaseComponents/Typography';
import { TermsModal } from './TermsModal';
import { Copy, Info } from './icons';
import styles from './styles.module.css';
import { useApplication } from '../../Contexts/ApplicationContext';
import { observer } from 'mobx-react-lite';
import { useAutoUpdateStep } from '../PaymentPage/TransactionPage/PendingTransactionPage';
export var PaymentWirePending = observer(function () {
    var _a;
    var _b = useState(false), termsOpen = _b[0], setTermsOpen = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useApplication(), cancelWirePayment = _d.orderFacade.cancelWirePayment, orderFacade = _d.orderFacade, currentStep = _d.stepController.currentStep;
    var wireInfo = 'wirePayment' in currentStep ? currentStep.wirePayment : null;
    var paymentAmount = orderFacade.exchangeInfo.payRealAmountString ||
        orderFacade.exchangeInfo.payAmountString;
    var paymentCurrency = ((_a = orderFacade.exchangeInfo.amounts.from.realCurrency) === null || _a === void 0 ? void 0 : _a.code) ||
        orderFacade.exchangeInfo.amounts.from.currency.code;
    useAutoUpdateStep();
    var config = [
        {
            name: 'Beneficiary',
            value: 'SWIPELUX OU',
        },
        {
            name: 'IBAN',
            value: (wireInfo === null || wireInfo === void 0 ? void 0 : wireInfo.iban) || '',
        },
        {
            name: 'BIC',
            value: 'REVOLT21',
        },
        {
            name: 'Bank institution',
            value: 'Revolut Bank UAB',
        },
        {
            name: 'Bank address',
            value: (_jsxs(_Fragment, { children: ["Konstitucijos ave. 21B,", _jsx("br", {}), "08130, Vilnius,", _jsx("br", {}), "Lithuania"] })),
            valueToCopy: 'Konstitucijos ave. 21B,08130, Vilnius,Lithuania',
        },
        {
            name: 'Reference ID',
            value: (wireInfo === null || wireInfo === void 0 ? void 0 : wireInfo.orderId) || '',
        },
        {
            name: 'Total payment',
            value: paymentAmount,
        },
    ];
    var copyToClipboard = function (text) {
        navigator.clipboard.writeText(text);
    };
    var cancelOrder = function () {
        setLoading(true);
        cancelWirePayment().finally(function () {
            setLoading(false);
        });
    };
    return (_jsxs(PageLayout, __assign({ loading: loading, hideHeaderChip: true, customBackClick: cancelOrder }, { children: [_jsx(TermsModal, { isOpen: termsOpen, onClose: function () { return setTermsOpen(false); } }), _jsxs(MainText, __assign({ style: { display: 'flex', alignItems: 'center', gap: 4 } }, { children: ["Payment details", _jsx(Info, { style: { cursor: 'pointer' }, onClick: function () { return setTermsOpen(true); } })] })), _jsxs("div", __assign({ className: styles.wrapper }, { children: [_jsxs(Text, __assign({ style: { marginTop: 16 } }, { children: ["Transfer ", paymentCurrency, " to Swipelux using the bank details provided."] })), _jsx("div", __assign({ className: styles.info }, { children: config.map(function (item) { return (_jsxs("div", __assign({ className: styles.info_row }, { children: [_jsx("div", __assign({ className: styles.info_row_name }, { children: item.name })), _jsx("div", __assign({ className: styles.info_row_value }, { children: item.value })), _jsx(Copy, { onClick: function () {
                                        copyToClipboard((item.valueToCopy || item.value));
                                    }, style: { cursor: 'pointer' } })] }), item.name)); }) })), _jsx("div", __assign({ className: styles.extra_info }, { children: "The order will continue automatically as soon as we receive the transfer." }))] }))] })));
});
